/**
 * Toast notification wrapper using Sonner
 */
import { toast as sonnerToast, ExternalToast } from 'sonner';

export const toast = {
  /**
   * Show success toast
   */
  success: (message: string, options?: ExternalToast) => {
    sonnerToast.success(message, options);
  },

  /**
   * Show error toast
   */
  error: (error: Error | string, options?: ExternalToast) => {
    const message = error instanceof Error ? error.message : error;
    sonnerToast.error(message, options);
  },

  /**
   * Show loading toast (returns ID for dismissal)
   */
  loading: (message: string, options?: ExternalToast) => {
    return sonnerToast.loading(message, options);
  },

  /**
   * Show info toast
   */
  info: (message: string, options?: ExternalToast) => {
    sonnerToast.info(message, options);
  },

  /**
   * Show warning toast
   */
  warning: (message: string, options?: ExternalToast) => {
    sonnerToast.warning(message, options);
  },

  /**
   * Dismiss a specific toast by ID
   */
  dismiss: (id: string | number) => {
    sonnerToast.dismiss(id);
  },

  /**
   * Dismiss all toasts
   */
  dismissAll: () => {
    sonnerToast.dismiss();
  },
};
